













import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/header/header.vue';
import Footer from '@/components/footer/footer.vue';
import LeftSidebar from '@/components/leftSidebar/leftSidebar.vue';
import ChatButton from '@/components/chatButton.vue';
import ZadarmaChat from '@/components/chat/zadarmaChat.vue';
import Overlay from '@/components/common/overlay.vue';
import { SidebarModuleMapper } from '@/store/modules/sidebar';
import { MenuModuleMapper } from '@/store/modules/menu';
import { ConfigsModuleMapper } from '@/store/modules/config';

const Mappers = Vue.extend({
  computed: {
    ...ConfigsModuleMapper.mapGetters(['jurisdiction']),
    ...SidebarModuleMapper.mapGetters(['sidebarState']),
  },
  methods: {
    ...SidebarModuleMapper.mapMutations({
      toggle: 'toggle',
    }),
    ...MenuModuleMapper.mapMutations({
      allItemClose: 'allItemClose',
    }),
  },
});

@Component({
  components: {
    Header,
    Footer,
    LeftSidebar,
    ChatButton,
    Overlay,
    ZadarmaChat,
  },
})
export default class DefaultLayout extends Mappers {
  resolutionBan = false;

  handleResize() {
    this.checkResolution();
  }

  mounted() {
    this.checkResolution();
  }

  get showZadarma(): boolean {
    return this.jurisdiction === 'CURACAO' && ['uz', 'uzb'].indexOf(this.$i18n.locale) !== -1;
  }

  get isSearchPage() {
    return this.$route.name === 'search';
  }

  checkResolution() {
    if (window.innerWidth < 1280) {
      this.resolutionBan = true;
    } else {
      this.resolutionBan = false;
    }
  }

  closeOverlay() {
    this.toggle(false);
  }
}
